import createCachedSelector from 're-reselect';

import { getDefaultTimeTargetingEditorState } from '../../service/TimeTargetingEditorHelper/TimeTargetingEditorHelper';
import { State } from '../../typings/state';
import { TimeTargetingEditorsState, TimeTargetingEditorState } from '../../typings/timeTargetingEditor';

export const selectTimeTargetingEditorValue = createCachedSelector(
    (state: State) => state.timeTargetingEditor,
    (state: State, editorId: string) => editorId,
    (editors: TimeTargetingEditorsState, editorId: string): TimeTargetingEditorState => {
        return editors[editorId] || getDefaultTimeTargetingEditorState();
    }
)((state: State, editorId: string) => editorId);
